import { DropDownList } from "@progress/kendo-react-dropdowns"
import { InputHLPure, CheckBoxHLPure, DataPickerHLPure } from "../../pures"
import { Grid } from "@material-ui/core"
import EditIcon from '../../../assets/logos/icons/editIcon.png'
import TrashIcon from '../../../assets/logos/icons/trashIcon.png'
import ArrowUp from '../../../assets/logos/icons/ri_arrow-up-line.png'
import ArrowDown from '../../../assets/logos/icons/ri_arrow-down-line.png'
import AngryIcon from '../../../assets/logos/icons/bx_angry.png'
import SmileIcon from '../../../assets/logos/icons/bx_smile.png'
import NeutralIcon from '../../../assets/logos/icons/bx_neutral.png'
import SadIcon from '../../../assets/logos/icons/bx_sad.png'
import HappyIcon from '../../../assets/logos/icons/bx_happy.png'
import { useTranslation } from "react-i18next"

const QuestionView = (props) => {
  let { deleteQuestion, id, setTypeQuestion, data, handleChangeQuestion, typeQuestion, setEditable, changeQuestionOrder, lastQuestion, justShowDetails } = props

  const defaultValue = typeQuestion?.find((element) => element.id === data.typeQuestionId)

  const { t: transl } = useTranslation('survey', { keyPrefix: 'surveyDetails' })
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <InputHLPure
            labelInput={transl("question")}
            typeInput={"text"}
            valueInput={data.name}
            handleChangeInput={(e) => handleChangeQuestion(e, id)}
            inputActive
            disabled
          />
        </Grid>
        <Grid item xs={3}>
          <label className="eticket-form-label" name="label">{transl("questionType")}</label>
          <DropDownList
            className="eticket-dropdown-field"
            data={typeQuestion?.length > 0 ? typeQuestion.map((type) => type.name) : []}
            defaultValue={defaultValue?.name}
            onChange={(event) => {
              const selectedAttribute = typeQuestion.find((element) => element.name === event.target.value)
              setTypeQuestion(selectedAttribute.id)
            }}
            disabled
          />
        </Grid>
        {
          // Question Text
          (data.typeQuestionId === 1) &&
          <Grid item xs={7} style={{ paddingTop: 0 }}>
            <InputHLPure
              labelInput={transl("questionType1Title")}
              typeInput={"text"}
              valueInput={data.config?.maxCharacters}
              // handleChangeInput={(e) => handleChangePostalCode(e)}
              inputActive
              disabled
            />
          </Grid>
        }
        {
          // Question Numeric
          (data.typeQuestionId === 2) &&
          <>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <InputHLPure
                labelInput={transl("questionType2-5Title1")}
                typeInput={"number"}
                valueInput={data.config?.minNum}
                // handleChangeInput={(e) => handleChangePostalCode(e)}
                inputActive
                disabled
              />
            </Grid>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <InputHLPure
                labelInput={transl("questionType2-5Title2")}
                typeInput={"number"}
                valueInput={data.config?.maxNum}
                // handleChangeInput={(e) => handleChangePostalCode(e)}
                inputActive
                disabled
              />
            </Grid>
          </>
        }
        {
          // Question Dropdown
          (data.typeQuestionId === 3 && data.questionOptions) &&
          <Grid item xs={12} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <label className="eticket-form-label" name="label">{transl("questionOptionsTitle")}</label>
            <DropDownList
              className="eticket-dropdown-field"
              data={data.questionOptions.map((option) => option)}
              defaultValue={data.questionOptions[0]}
            />
          </Grid>
        }
        {
          // Question Checkbox
          (data.typeQuestionId === 4 && data.questionOptions) &&
          <>
            <Grid item xs={12} style={{ paddingBottom: 0, paddingTop: 0 }}>
              <label className="eticket-form-label" name="label">{transl("questionOptionsTitle")}</label>
            </Grid>
            <Grid container style={{ padding: '6px 12px' }}>
              {
                data.questionOptions.map((value, key) => {
                  return (
                    <>
                      <Grid item xs={10}>
                        <CheckBoxHLPure
                          labelCheckBox={value}
                          valueCheckBox={value}
                        />
                      </Grid>
                    </>
                  )
                })
              }
            </Grid>
          </>
        }
        {
          // Question Datepicker
          (data.typeQuestionId === 5) &&
          <>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <DataPickerHLPure className="element"
                stylePicker={{ marginBottom: '16px' }}
                labelDataPicker={transl("questionType2-5Title1")}
                valueDate={data.config?.minDate}
                disabled
              />
            </Grid>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <DataPickerHLPure className="element"
                stylePicker={{ marginBottom: '16px' }}
                labelDataPicker={transl("questionType2-5Title2")}
                valueDate={data.config?.maxDate}
                disabled
              />
            </Grid>
          </>
        }
        {
          // Question Scale
          data.typeQuestionId === 6 &&
          <Grid container justifyContent="center" style={{ paddingBottom: '12px' }}>
            <Grid style={{ display: 'flex', justifyContent: 'center' }} item xs={2}>
              <img src={AngryIcon} />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center' }} item xs={2}>
              <img src={SadIcon} />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center' }} item xs={2}>
              <img src={NeutralIcon} />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center' }} item xs={2}>
              <img src={SmileIcon} />
            </Grid>
            <Grid style={{ display: 'flex', justifyContent: 'center' }} item xs={2}>
              <img src={HappyIcon} />
            </Grid>
          </Grid>
        }
      </Grid>

      <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-start' }}>
        <div style={{ display: 'flex' }}>
          {
            // Aditional details for numeric
            data.typeQuestionId === 2 &&
            <>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  disabled
                  labelCheckBox={transl("questionOption1")}
                  valueCheckBox={'Numero entero'}
                  checkedState={data.config?.wholeNumber}
                />
              </div>
            </>
          }
          {
            // Aditional details for datepicker
            data.typeQuestionId === 5 &&
            <>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  disabled
                  labelCheckBox={transl("questionType5Title1Date")}
                  valueCheckBox={'Fecha'}
                  checkedState={data.config?.date}
                />
              </div>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  disabled
                  labelCheckBox={transl("questionType5Title2Time")}
                  valueCheckBox={'Hora'}
                  checkedState={data.config?.hour}
                />
              </div>
            </>
          }
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
            <CheckBoxHLPure
              disabled
              labelCheckBox={transl("questionOption2")}
              valueCheckBox={'Obligatoria'}
              checkedState={data.config?.required}
            />
          </div>
        </div>
      </div>
      {
        !justShowDetails && <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
          <img style={{ marginRight: '5px', cursor: 'pointer' }} src={TrashIcon} onClick={deleteQuestion} />
          <img style={{ marginRight: '5px', cursor: 'pointer' }} src={EditIcon} onClick={setEditable} />
          <img style={{ marginRight: '5px', cursor: 'pointer' }} src={ArrowUp} onClick={() => {
            if (id !== 0) {
              changeQuestionOrder('subs')
            }
          }} />
          <img style={{ cursor: 'pointer' }} src={ArrowDown} onClick={() => {
            if (lastQuestion !== id) {
              changeQuestionOrder('sum')
            }
          }} />
        </div>
      }
    </>
  )
}

export default QuestionView